import { useState, useEffect } from "react";
import axios from "axios";
import config from "./../config";

const devLog = (...args) => {
  if (config.IS_DEV) {
    console.log(...args);
  }
};

const useSubscriptionStatus = (userId) => {
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      devLog("Starting fetch for subscription status", { userId });
      try {
        const response = await axios.post(
          "https://lykns00a87.execute-api.us-east-2.amazonaws.com/default/football_app_data_crud",
          {
            operationType: "check_coach_subscription",
            data: { coach_id: userId },
          }
        );
        devLog("Full API response:", response);

        // Parse response to extract `subscription_type`
        const { subscription_type } = response.data.body
          ? JSON.parse(response.data.body)
          : response.data;

        setSubscriptionStatus(subscription_type);
        devLog("Extracted subscription type:", subscription_type);
      } catch (err) {
        console.error("Error fetching subscription status:", err);
        setError("Failed to fetch subscription status.");
        devLog("Error details:", err.response ? err.response.data : err);
      } finally {
        setLoading(false);
        devLog("Subscription status fetch completed.");
      }
    };

    if (userId) {
      devLog("Valid userId provided, triggering fetchStatus.");
      fetchStatus();
    } else {
      devLog("No userId provided, skipping fetch.");
      setLoading(false);
    }
  }, [userId]);

  return { subscriptionStatus, loading, error };
};

export default useSubscriptionStatus;
